import {writable} from 'svelte/store';

export type DurationType = {[key: string]: {in?: number; out?: number}};

const initialValue = {
    flip: {
        in: 0,
        out: 600,
    },
    opacity: {
        in: 350,
        out: 350,
    },
};

const createDurationMapStore = () => {
    const {subscribe, update, set} = writable(<DurationType>{...initialValue});

    return {
        subscribe,
        update: (key: string, newValue: {in?: number; out?: number}) =>
            update(value => {
                value[key] = {...value[key], ...newValue};
                return value;
            }),
        setInitialValue: () => set({...initialValue}),
    };
};

export const duration = createDurationMapStore();
